import { useSymbolStore } from '@/stores/symbol';
import PanelContainer from '../panel-container';
import SymbolContainer from '../symbol-container';
import EmojiBlocks from './emoji-blocks';

const EmojiPanel = () => {
  const selectedSymbol = useSymbolStore((s) => s.selectedSymbol);

  return (
    <PanelContainer visible={selectedSymbol === 'emoji'}>
      <SymbolContainer slug={selectedSymbol}>
        <EmojiBlocks />
      </SymbolContainer>
    </PanelContainer>
  );
};

export default EmojiPanel;
